export const SelectField = ({
    label,
    value,
    onChange,
    options,
    error,
    required,
    idSuffix = "",
    defaultOptionLabel = "Select...",
}) => (
    <div>
        <label
            htmlFor={`${label.toLowerCase().replace(/\s/g, "-")}-${idSuffix}`}
            className="text-[11px] font-bold text-gray-600 uppercase tracking-wider"
        >
            {label}
            {required && <span className="text-red-500">*</span>}
        </label>
        <select
            id={`${label.toLowerCase().replace(/\s/g, "-")}-${idSuffix}`}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            required={required}
            className={`mt-1 block w-full pl-3 pr-10 py-2 text-base border ${error ? "border-red-500" : "border-slate-300"
                } focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm rounded-md `}
            aria-invalid={!!error}
            aria-describedby={
                error
                    ? `${label.toLowerCase().replace(/\s/g, "-")}-${idSuffix}-error`
                    : undefined
            }
        >
            <option value="" disabled>
                {defaultOptionLabel}
            </option>
            {options?.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
        {error && (
            <p
                id={`${label.toLowerCase().replace(/\s/g, "-")}-${idSuffix}-error`}
                className="mt-1 text-xs text-red-600"
            >
                {error}
            </p>
        )}
    </div>
);